import axios from 'axios';
import apiClient from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1/admin';
const FILE_BASE_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '');

export const normalizeFileUrl = (url?: string) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${FILE_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

// 文件配置
export interface FileConfig {
  id: string;
  name: string;
  code: string;
  storageType: string;
  bucket: string;
  endpoint?: string;
  accessKey: string;
  region?: string;
  basePath: string;
  baseUrl: string;
  port: number;
  maxSize: number;
  allowedTypes: string;
  isDefault: number;
  status: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
}

// 文件记录
export interface FileRecord {
  id: string;
  configId: string;
  name: string;
  path: string;
  url: string;
  size: number;
  ext: string;
  mimeType: string;
  md5: string;
  storageType: string;
  category: string;
  uploadUserId: string;
  uploadUsername: string;
  downloadCount: number;
  status: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
}

// 存储类型选项
export const storageTypeOptions = [
  { value: 'local', label: '本地磁盘' },
  { value: 'database', label: '数据库' },
  { value: 'ftp', label: 'FTP服务器' },
  { value: 'sftp', label: 'SFTP服务器' },
  { value: 's3', label: 'S3对象存储' },
  { value: 'qiniu', label: '七牛云' },
];

// 文件配置API
export const listConfigs = (params?: any) =>
  apiClient.get('/files/configs', { params });

export const getConfig = (id: string) =>
  apiClient.get(`/files/configs/${id}`);

export const createConfig = (data: Partial<FileConfig>) =>
  apiClient.post('/files/configs', data);

export const updateConfig = (id: string, data: Partial<FileConfig>) =>
  apiClient.put(`/files/configs/${id}`, data);

export const deleteConfig = (id: string) =>
  apiClient.delete(`/files/configs/${id}`);

// 文件管理API
export const listFiles = (params?: any) =>
  apiClient.get('/files', { params });

export const uploadFile = (file: File, category?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  if (category) {
    formData.append('category', category);
  }
  return apiClient.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteFile = (id: string) =>
  apiClient.delete(`/files/${id}`);

export const batchDeleteFiles = (ids: string[]) =>
  apiClient.post('/files/batch-delete', { ids });

export const getFileStats = () =>
  apiClient.get('/files/stats');

// 获取下载URL（强制下载）
export const getDownloadUrl = (id: string) =>
  `/api/v1/admin/files/${id}/download`;

// 下载文件（带token）
export const downloadFile = async (id: string, fileName: string) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(
    `${API_BASE_URL}/files/${id}/download`,
    {
      responseType: 'blob',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  );

  // 创建下载链接
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// 格式化文件大小
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
